export enum ManagedDocumentsFilterTypes {
    COUNTRY =  "Countries",
    UPDATED_ON = "createdOn",
    UPLOADED_BY = "createdBy",
    STATUS = "status",
    ISARCHIVE="IsArchived"

}